// App.tsx
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import Home from "./pages/Home";
import Login from "./pages/Login"; // Import the updated Login component
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute"; // Import the ProtectedRoute
import './App.scss';
import Products from "./pages/Products";
import SingleProduct from "./pages/SingleProduct";
import Config from "./pages/Config/Config";
import AdminRoute from "./components/AdminRoute/AdminRoute";
import AdminLayout from "./AdminLayout";
import HomeConfig from "./pages/Config/HomeConfig";
import AdminLogin from "./pages/Config/AdminLogin";
import SettingsConfig from "./pages/Config/SettingsConfig";
import Checkout from "./pages/Checkout";
import ProductsConfig from "./pages/Config/ProductsConfig";
import useCategoryStore from "./store/categoryStore";
import Favourites from "./pages/Favourites";


// Define routes for sidebar
const sidebarRoutes = [
  { path: "/", element: <Home />, label: "Home" },
];
const sidebarAdminRoutes = [
  { path: "/config", element: <Config />, label: "Config" },
  { path: "/config/home", element: <HomeConfig />, label: "Home" },
  { path: "/config/products", element: <ProductsConfig />, label: "Products" },
  { path: "/config/settings", element: <SettingsConfig />, label: "Settings" },
  
];


const App: React.FC = () => {
  const {getCategories,getBrands} = useCategoryStore();
;
  useEffect(() => {
    const initialize = async () => {
      await Promise.all([getCategories(), getBrands()]);
    }
    initialize();
  }, [getCategories,getBrands]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Layout isLoginPage><Login /></Layout>} />
        <Route
          path="/"
          element={
            <Layout sideBarLinks={sidebarRoutes}>
              <Home />
            </Layout>
          }
        />
         <Route
          path="/products"
          element={
            <Layout sideBarLinks={sidebarRoutes}>
              <Products />
            </Layout>
          }
        />
          <Route
          path="/checkout"
          element={
            <Layout sideBarLinks={sidebarRoutes}>
              <ProtectedRoute element={<Checkout />} />
            </Layout>
          }
        />
             <Route
          path="/favourites"
          element={
            <Layout sideBarLinks={sidebarRoutes}>
              <ProtectedRoute element={<Favourites />} />
            </Layout>
          }
        />
         <Route
          path="/product/:code"
          element={
            <Layout sideBarLinks={sidebarRoutes}>
              <SingleProduct />
            </Layout>
          }
        />
           {/* config */}
      <Route path="/ad-backdoor" element={<AdminLayout isLoginPage><AdminLogin /></AdminLayout>} />
      <Route
          path="/config"
          element={
            <AdminLayout sideBarLinks={sidebarAdminRoutes}>
                  <AdminRoute element={<Config/>} />
            </AdminLayout>
          }
        />
        <Route
          path="/config/home"
          element={
            <AdminLayout sideBarLinks={sidebarAdminRoutes}>
                  <AdminRoute element={<HomeConfig/>} />
            </AdminLayout>
          }
        />
        <Route
          path="/config/products"
          element={
            <AdminLayout sideBarLinks={sidebarAdminRoutes}>
                  <AdminRoute element={<ProductsConfig/>} />
            </AdminLayout>
          }
        />
         <Route
          path="/config/settings"
          element={
            <AdminLayout sideBarLinks={sidebarAdminRoutes}>
                  <AdminRoute element={<SettingsConfig/>} />
            </AdminLayout>
          }
        />
      </Routes>

   
    </Router>
  );
};

export default App;
